import * as Preact from "preact"

import "@fae/source/views/ModalUI.less"

import UnitSprite from "@fae/source/views/components/UnitSprite.jsx"
import DialogueBox from "@fae/source/views/components/DialogueBox.jsx"
import DialogueLog from "@fae/source/views/components/DialogueLog.jsx"
import UnitHealthBar from "@fae/source/views/components/UnitHealthBar.jsx"
import UnitExperienceBar from "@fae/source/views/components/UnitExperienceBar.jsx"
import SkillPreview from "@fae/source/views/components/SkillPreviewUI.jsx"

import App from "@fae/source/models/App.js"
import Stage from "@fae/source/models/Stage.js"

import unitJobs from "@fae/source/data/unitJobs.js"

class DialogueLogModal {
    render() {
        return <DialogueLog stage={this.props.stage}/>
    }
}

class DialogueBoxModal {
    render() {
        return <DialogueBox stage={this.props.stage}/>
    }
}

class DialogueChoiceModal {
    render() {
        return (
            <DialogueBox stage={this.props.stage}>
                <div class="DialogueOptions" isReady={this.props.stage.dialogue.index >= this.props.stage.dialogue.text.length - 1}>
                    {this.props.stage.dialogue.data.options.map((option, index) => {
                        if(option.text != undefined) {
                            return (
                                <div class="Option" onClick={this.onClickOption(option)}>
                                    {index}. {option.text}
                                </div>
                            )
                        }
                        return (
                            <div class="Option" onClick={this.onClickOption(option)}>
                                {index}. {option}
                            </div>
                        )
                    })}
                </div>
            </DialogueBox>
        )
    }
    onClickOption(option) {
        return (event) => {
            if(option.result != undefined) {
                this.props.stage.flags[option.result.flagname] = option.result.value
            } else {
                this.props.stage.flags[this.props.stage.dialogue.data.flagname] = option
            }
            const step = App.sequence.steps.shift()
            App.sequence = {
                "steps": Stage.processEventSteps(Stage.copy(this.props.stage), step.followingProtosteps) // TODO: see CarryOn.js
            }
            if(App?.game?.chapter?.stage != undefined
            && App.sequence.steps[App.sequence.steps.length - 1]?.omegastage != undefined) {
                App.game.chapter.stage = App.sequence.steps[App.sequence.steps.length - 1].omegastage
            }
        }
    }
}

class CharacterSelectModal {
    render() {
        const dialogue = this.props.stage.dialogue
        if(dialogue?.data?.options == undefined) return "..."
        return (
            <div class="CharacterSelectModal">
                <div class="CallToAction">
                    -- {dialogue.data.label || "Choose your Character"} --
                </div>
                <div class="SelectableCharacters">
                    {dialogue.data.options.map((option) => {
                        const unit = this.props.stage.units[option.unitKey] || {"isDead": true}
                        return (
                            <div class="SelectableCharacter" onClick={this.onClickOption(option)} isDead={unit.isDead} isHidden={option.isHidden}>
                                <div class="Color" style={{"background-color": unit.color || "hotpink"}}/>
                                <div class="Portrait" expression="neutral" style={{
                                    "background-image": "url(" + unit.portraits?.neutral + ")"
                                }}/>
                                <div class="Portrait" expression="happy" style={{
                                    "background-image": "url(" + (unit.portraits?.hovered || unit.portraits?.flavor || unit.portraits?.happy) + ")"
                                }}/>
                                <div class="Details">
                                    <div class="Name" style={{"background-color": unit.color || "hotpink"}}>
                                        {unit.title || unit.name}
                                    </div>
                                    <div class="Class" style={{"background-color": unit.color || "hotpink"}}>
                                        {unit.subtitle || unit.jobName} {unit.level && "Lv" + unit.level}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
    onClickOption(option) {
        return (event) => {
            if(option.isHidden) return
            if(this.props.stage.units[option.unitKey] == undefined) return
            if(this.props.stage.units[option.unitKey].isDead == true) return
            let nextSteps = option.steps.concat(App.sequence.steps.shift().followingProtosteps) // TODO: see CarryOn.js

            App.sequence = {}
            App.sequence.steps = Stage.processEventSteps(Stage.copy(this.props.stage), nextSteps)
            if(App?.game?.chapter?.stage != undefined
            && App.sequence.steps[App.sequence.steps.length - 1]?.omegastage != undefined) {
                App.game.chapter.stage = App.sequence.steps[App.sequence.steps.length - 1].omegastage
            }
        }
    }
}

class CharacterLevelUpModal {
    render() {
        const unitKey = this.props.stage.dialogue?.data?.unitKey
        if(unitKey == undefined) return
        const unit = this.props.stage.units[unitKey]
        if(unit == undefined) return
        return (
            <div class="CharacterLevelUpModal">
                {unit?.portraits && unit?.portraits["happy"] && <img class="Portrait" src={unit.portraits["happy"]}/>}
                <div class="Details">
                    <section class="HeaderSection">
                        <div class="Thumbnail">
                            <UnitSprite unit={unit}/>
                        </div>
                        <div class="Declaration">Level Up!!</div>
                        <div class="Level">
                            Level {unit.level}
                            <span class="arrow"/>
                            {unit.level + 1}
                        </div>
                    </section>
                    {((unit.levelups && unit.levelups[unit.level + 1]) || []).map((levelupPerk) => {
                        if(levelupPerk.key == "maxhealth") {
                            return (
                                <section class="PerksSection">
                                    <div class="Label">Health Increased</div>
                                    <div class="BigText">
                                        {unit.maxhealth}hp
                                        <span class="arrow"/>
                                        {unit.maxhealth + levelupPerk.value}hp
                                    </div>
                                </section>
                            )
                        } else if(levelupPerk.key == "jobKey") {
                            if(unitJobs[levelupPerk.value] == undefined) return
                            return (
                                <section class="PerksSection">
                                    <div class="Label">Promoted!!</div>
                                    <div class="UnitJob">
                                        <div class="Thumbnail">
                                            <UnitSprite unit={unitJobs[levelupPerk.value]}/>
                                        </div>
                                        <div class="Text">{unitJobs[levelupPerk.value].jobName}</div>
                                        {(unitJobs[levelupPerk.value].facts || []).map((fact) => {
                                            return (
                                                <div class="Fact">
                                                    <div class="SmallText">{fact}</div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </section>
                            )
                        } else if(levelupPerk.key == "jobKeys") {
                            return (
                                <section class="PerksSection">
                                    <div class="Label">Promoted!! Pick a prestige:</div>
                                    <div class="UnitJobs">
                                        {levelupPerk.values.map((value) => {
                                            if(unitJobs[value] == undefined) return
                                            return (
                                                <div class="UnitJob" onClick={this.onClickUnitJob({"newUnitJobKey": value})}>
                                                    <div class="Thumbnail">
                                                        <UnitSprite unit={unitJobs[value]}/>
                                                    </div>
                                                    <div class="Text">{unitJobs[value].jobName}</div>
                                                    {(unitJobs[value].facts || []).map((fact) => {
                                                        return (
                                                            <div class="Fact">
                                                                <div class="SmallText">{fact}</div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </section>
                            )
                        } else if(levelupPerk.key == "skill") {
                            return (
                                <section class="PerksSection">
                                    <div class="Label">Skill Unlocked!!</div>
                                    <div class="Value">{levelupPerk.value}</div>
                                </section>
                            )
                        }
                    })}
                </div>
            </div>
        )
    }
    onClickUnitJob({newUnitJobKey}) {
        return (event) => {
            this.props.stage.dialogue.data.newUnitJobKey = newUnitJobKey
            App.sequence.steps.shift()
        }
    }
}

class ChapterSuccessModal {
    render() {
        const phase = this.props.stage.dialogue?.data?.phase
        const enemyUnits = Object.values(this.props.stage.units).filter((unit) => {
            return unit.affiliation == "bad" //&& unit.isDead == true
        })
        const allyUnits = Object.values(this.props.stage.units).filter((unit) => {
            return unit.affiliation == this.props.stage.player.affiliation
                && (unit.type != "spot" && unit.type != "zone")
        })
        return (
            <div class="ChapterSuccessModal" isShown={phase >= 1}>
                <div class="Box">
                    <section class="HeaderSection">
                        <div class="Declaration" isShown={phase >= 1.5}>{this.props.stage.dialogue?.data?.message || "Victory!!"}</div>
                        <div class="Objectives" isShown={phase >= 2}>☆☆☆</div>
                    </section>
                    <section class="EnemySection" isShown={phase >= 3}>
                        <div class="Label">Enemies:</div>
                        <div class="Units">
                            {enemyUnits.map((unit, index) => {
                                if(index > 10) return
                                return (
                                    <div class="Unit" isTight={true} isAnimated={phase == 3} style={{
                                        "animation-delay": phase > 3 ? 0 : 0.5 + (index * 0.2) + "s"
                                    }}>
                                        <UnitSprite unit={unit}/>
                                    </div>
                                )
                            })}
                        </div>
                    </section>
                    <section class="AllySection" isShown={phase >= 4}>
                        <div class="Label">Allies:</div>
                        <div class="Units">
                            {allyUnits.map((unit) => (
                                <div class="Unit" isAnimated={phase == 4}>
                                    <UnitSprite unit={unit} recolor={phase >= 5 && unit.isDead == true && "grayscaled"}/>
                                    <UnitExperienceBar unit={this.props.stage.player.units[unit.key]} isVisible={phase >= 6 && (unit.isDead != true || App.game.configuration.preserveExperienceEvenAfterDeath == true)}/>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}

class CharacterDraftModal {
    render() {
        const stage = this.props.stage
        const dialogue = this.props.stage.dialogue

        if(dialogue == undefined) return
        if(dialogue?.data?.unitJobKeys == undefined) return

        return (
            <div class="CharacterDraftModal">
                <div class="Box">
                    <div class="Prompt">Pick a Thrall</div>
                    <div class="Cards">
                        {dialogue.data.unitJobKeys.map((unitJobKey) => {
                            const unit = Objdict.merge(unitJobs[unitJobKey], dialogue.data.maskUnit || {})
                            if(unit == undefined) return
                            return (
                                <div class="Card" onClick={this.onClickCard(unit)}>
                                    <div class="Thumbnail">
                                        <UnitSprite unit={unit}/>
                                    </div>
                                    <div class="Name">
                                        {unitJobKey}
                                    </div>
                                    {unit.facts && unit.facts.map((fact) => {
                                        return (
                                            <div class="Fact">
                                                {fact}
                                            </div>
                                        )
                                    })}
                                    {unit.skillKeys.map((skillKey) => {
                                        const skill = skills[skillKey]
                                        if(skill == undefined) return
                                        if(skill.description == undefined) return
                                        return (
                                            <div class="Fact">
                                                {skill.description}
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
    onClickCard(unit) {
        return (event) => {
            const baseUnit = {
                "key": nanoid(),
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 40,

                "level": 1,
                "maxexperience": 100,
                "levelups": {
                    2: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 100},
                        {"key": "jobName", "value": "Ghoul"},
                    ],
                    3: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 100},
                        {"key": "jobName", "value": "Wight"},
                    ],
                    4: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 100},
                        {"key": "jobName", "value": "Shade"},
                    ],
                    5: [
                        {"key": "maxhealth", "value": 10},
                        {"key": "maxexperience", "value": 100},
                        {"key": "jobName", "value": "Revenant"},
                    ],
                },
            }
            const newUnit = Objdict.merge(unit, baseUnit)
            App.game.player.units[newUnit.key] = newUnit
            Navigation.go(this.props.stage.dialogue.data.nextURL)
        }
    }
}

class CharacterSplashModal {
    render() {
        const stage = this.props.stage
        const dialogue = this.props.stage.dialogue
        const unit = stage.units[dialogue?.data?.unitKey]
        if(dialogue == undefined) return
        if(unit == undefined) return
        return (
            <div class="CharacterSplashModal">
                <div class="Splash">
                    <div class="Color" style={{"background-color": unit.color || "hotpink"}}/>
                    <div class="Portrait" expression="happy" style={{
                        "background-image": "url(" + (unit.portraits?.flavor || unit.portraits?.happy) + ")"
                    }}/>
                </div>
                <div class="Details">
                    <section class="HeaderSection" style={{"background-color": unit.color || "hotpink"}}>
                        <div class="Name">{unit.name}</div>
                    </section>
                    <section class="MainSection">
                        <div class="Description">
                            {unit.introduction?.description}
                        </div>
                        <SkillPreview demo={unit.introduction?.demo}/>
                    </section>
                </div>
            </div>
        )
    }
}

class TutorialDemoModal {
    render() {
        const stage = this.props.stage
        const dialogue = this.props.stage.dialogue
        if(dialogue == undefined) return
        if(dialogue.data == undefined) return
        return (
            <div class="TutorialDemoModal">
                <section class="MainSection">
                    <div class="Description">
                        {dialogue.data.description}
                    </div>
                    <SkillPreview demo={dialogue.data.demo}/>
                </section>
            </div>
        )
    }
}

class DeclarationModal {
    render() {
        return (
            <div class="DeclarationModal" style={this.style}>
                <div class="Text">{this.props.stage.dialogue.text}</div>
            </div>
        )
    }
    get style() {
        return {
            "background-color": this.props.stage.dialogue.data?.color
        }
    }
}

class ChapterStartModal {
    render() {
        const text = this.props.stage.dialogue?.data?.text || []
        return (
            <div class="ChapterStartModal">
                <div class="Chapter">{text[0] || "Chapter 1"}</div>
                <div class="Title">{text[1] || "The Beginning"}</div>

                <div class="InWhich">{text[2]}</div>
                <div class="First Subtitle">{text[3]}</div>
                <div class="Second Subtitle">{text[4]}</div>
            </div>
        )
    }
}

class TurnStartModal {
    render() {
        return (
            <div class="TurnStartModal" key={this.props.stage.dialogue?.data.affiliation}>
                <div class="Message">
                    {this.props.stage.dialogue.data?.affiliation == this.props.stage.player.affiliation ? "YOUR TURN" : "ENEMY TURN"}
                </div>
            </div>
        )
    }
}

class ChapterSuccessClassicModal {
    render() {
        return (
            <div class="ChapterSuccessClassicModal">
                <div class="Declaration">Victory!!</div>
            </div>
        )
    }
}

class ChapterFailureModal {
    render() {
        return (
            <div class="ChapterFailureModal">
                <div class="Predeclaration">You have been</div>
                <div class="Declaration">{App.game?.failure?.verb || "Defeated"}</div>
            </div>
        )
    }
}

class TransitionModal {
    render() {
        return (
            <div class="TransitionModal"
                type={this.props.stage.dialogue.data?.type}
                phase={this.props.stage.dialogue.data?.phase}/>
        )
    }
}

class BlackoutDialogueModal {
    render() {
        return <DialogueBox stage={this.props.stage} blackout={true} centered={true}/>
    }
}

class PresentationDialogueModal {
    render() {
        return [
            <div class="Presentation">
                {this.props.stage.dialogue?.data?.presentation}
            </div>,
            <DialogueBox stage={this.props.stage}/>
        ]
    }
}

class DemoDialogueModal {
    render() {
        return [
            <div class="Demo">
                <SkillPreview demo={this.props.stage.dialogue?.data?.demo}/>
            </div>,
            <DialogueBox stage={this.props.stage}/>
        ]
    }
}

class WaitingModal {
    render() {
        return (
            <div class="WaitingModal">
                <div class="Box">
                    <div class="Label">{this.props.stage.dialogue?.data?.label}</div>
                    <div class="Spinner"/>
                </div>
                <div class="Tip">
                    <div class="Text">
                        {this.props.stage.dialogue?.data?.tip}
                    </div>
                </div>
            </div>
        )
    }
}

class ContractModal {
    render() {
        return (
            <div class="ContractModal">
                <img src={require("@fae/source/assets/images/book-tactics/contract.png")}/>
                <form onSubmit={(event) => {
                    event.preventDefault()
                    App.sequence.steps.pop()
                    App.sequence.steps.pop()
                    App.sequence.steps.pop()
                    App.sequence.steps.pop()
                }}>
                    <div class="FormInput">
                        <label for="name">Name: </label>
                        <input type="text" id="name" name="name"/>
                    </div>
                    <button>Agree</button>
                </form>
            </div>
        )
    }
}

class CustomViewModal {
    render() {
        let view = this.props.stage.dialogue?.data?.view
        if(view instanceof Function) {
            view = view(this.props.stage)
        }
        return (
            <div class="CustomViewModal">
                {view}
            </div>
        )
    }
}

// TODO: this is redundant with CustomViewModal
class GameplayModal {
    render() {
        let view = this.props.stage.dialogue?.data?.view
        if(view instanceof Function) {
            view = view()
        }
        return (
            <div class="GameplayModal">
                {view}
            </div>
        )
    }
}

export const Modals = {
    "ChapterStart": ChapterStartModal,
    "ChapterFailure": ChapterFailureModal,
    "TurnStart": TurnStartModal,
    "ChapterSuccess": ChapterSuccessModal,
    "ChapterSuccessClassic": ChapterSuccessClassicModal,
    "CharacterLevelUp": CharacterLevelUpModal,
    "DialogueBox": DialogueBoxModal,
    "DialogueLog": DialogueLogModal,
    "DialogueChoice": DialogueChoiceModal,
    "BlackoutDialogue": BlackoutDialogueModal,
    "PresentationDialogue": PresentationDialogueModal,
    "DemoDialogue": DemoDialogueModal,
    "CharacterSelect": CharacterSelectModal,
    "CharacterSplash": CharacterSplashModal,
    "CharacterDraft": CharacterDraftModal,
    "TutorialDemo": TutorialDemoModal,
    "Declaration": DeclarationModal,
    "Transition": TransitionModal,
    "Gameplay": GameplayModal,
    "Waiting": WaitingModal,
    "Contract": ContractModal,
    "CustomView": CustomViewModal,
}

export default class ModalUI {
    render() {
        if(this.props.stage == undefined) return
        if(this.props.stage.dialogue == undefined) return


        const Modal = Modals[this.props.stage.dialogue.type || "DialogueBox"]
        if(Modal != undefined) {
            return (
                <div class="ModalUI">
                    <Modal stage={this.props.stage}/>
                </div>
            )
        }
    }
}
